import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  X,
  Building,
  User,
  Mail,
  Phone,
  MapPin,
  Calendar,
  FileText,
  MessageSquare,
  DollarSign,
  Shield,
  Users,
  Plus,
  Edit,
  Trash2,
  Eye,
  Download,
  Star,
  Clock,
  CheckCircle2,
  AlertCircle,
  CreditCard,
  Briefcase,
  Settings,
  Target,
  TrendingUp,
  Activity
} from "lucide-react";
import axios from "../axios/AxiosInstance";
import { Input, Modal, Select, TreeSelect, message } from "antd";
import ClientComment from "./ClientComment";
import ClientDocuments from "./ClientDocuments";
import CreateQuotationModal from "./CreateQuotationModal";
import CreateContract from "./CreateContract/CreateContract";
import jsPDF from "jspdf";
import cgvClient from "../assets/img/img/cgv-client.jpg";
import myImage from "../assets/img/img/logopdf.png";
import logotoulouse from "../assets/img/img/logotoulouse.png";
import logobrive from "../assets/img/img/logobrive.png";
import gmail from "../assets/img/img/gmail.png";
import phone from "../assets/img/img/phone.png";
import qualifications from "../utils/qualifications";

//import CreateContract from './CreateContract'
//import ClientModalContract from './ClientModalContract'
//import DuplicateContract from './DuplicateContract'
const ClientDetail = ({
  client,
  setClient,
  clients,
  setClients,
  originalClients,
}) => {
  const [section, setSection] = useState("info");
  const [acceptedAtradius, setAcceptedAtradius] = useState(false);
  const [updateContactObject, setUpdateContactObject] = useState({});
  const [pld, setPld] = useState("");

  const [contacts, setContacts] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [originalQuotations, setOriginalQuotations] = useState([]);
  const [isOpenCreateContact, setIsOpenCreateContact] = useState(false);
  const [isOpenCreateTask, setIsOpenCreateTask] = useState(false);
  const [canCreateContract, setCanCreateContrat] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [epis, setEpis] = useState([]);
  const [isCreateFacture, setIsCreateFacture] = useState(false);
  const [isCreatePldContract, setIsCreatePldContract] = useState(false);
  const [clientQualifications, setClientQualifications] = useState([]);
  const [clientChantiers, setClientChantiers] = useState([]);
  const [isAskAtradius, setIsAskAtradius] = useState(false);
  const [isLoadingAtradius, setIsLoadingAtradius] = useState(false);
  const [isDuplicateContract, setIsDuplicateContract] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [cover, setCover] = useState(null);
  const [loadedCover, setLoadedCover] = useState(false);
  const [amount, setAmount] = useState("");
  const [isCreateQuotation, setIsCreateQuotation] = useState(false);
  const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);

  useEffect(() => {
    loadQuotations(client._id);
    loadQualifications();
    getCover();
  }, []);

  const loadQualifications = () => {
    if (!client.pld) {
      setCanCreateContrat(false);
      console.log("pas de pld");
      return;
    }
    axios
      .get(`client/qualifications/${client.pld}`)
      .then((res) => {
        console.log(res.data);
        if (res.data.length > 0) {
          setCanCreateContrat(true);
          setClientQualifications(res.data.TabQualifications);
          setClientChantiers(res.data.TabChantiers);
        }
      })
      .catch((e) => console.log(e));
  };

  const getCover = () => {
    axios
      .get(`cover/client/${client._id}`)
      .then((res) => {
        console.log(res.data);
        if (res.data.length) {
          setCover(res.data[0]);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setLoadedCover(true));
  };

  const loadQuotations = (clientId) => {
    axios
      .get(`quotation/by-client/${clientId}`)
      .then((res) => {
        const quotations = res.data.sort(
          (a, b) => b.quotationNumber - a.quotationNumber,
        );
        setQuotations(quotations);
        setOriginalQuotations(quotations);
        console.log(res.data);
      })
      .catch((e) => {
        message.error("erreur");
      });
  };

  const episList = [
    "Gants",
    "Lunette",
    "Protection",
    "Blouse",
    "Bleu",
    "Chaussures",
    "Auditive",
    "Casque",
    "Harnais",
    "Gilet",
    "Autre..",
  ];

  const epiData = episList.map((epi) => {
    return {
      title: epi,
      value: epi,
      key: epi,
    };
  });

  const onChangeEpi = (newValue) => {
    setEpis(newValue);
  };

  const generatePDF = (quotation, viewOnly = false) => {
    setIsLoadingQuotation(true);

    try {
    // Fallbacks pour éviter les 500/crashes PDF quand l'objet devis
    // (souvent créé côté admin) n'a pas tous les champs peuplés.
    const defaultAgency = {
      name: "J'M INTERIM",
      address: "4 Avenue Laurent Cély, Hall A",
      postCode: "92600",
      town: "Asnières sur Seine",
      siret: "91912551800010",
      tva: "FR52919125518",
      email: "contact@jm-interim.com",
      phone: "01 80 88 21 35",
    };
    const agency = quotation.agency || defaultAgency;
    const client = quotation.client || {};
    const products = Array.isArray(quotation.products) ? quotation.products : [];
    const mainProduct = products[0]?.product || "";

    const pdf = new jsPDF({
      unit: "mm",
      format: [210, 297],
    });

    const img = new Image();
    if (agency.name === "CAPENEO") {
      img.src = logotoulouse;
      pdf.addImage(img, "PNG", 14, 10, 40, 24);
    } else if (agency.name === "J'M CAPENEO") {
      img.src = logobrive;
      pdf.addImage(img, "PNG", 24, 14, 32, 24);
    } else {
      img.src = myImage;
      pdf.addImage(img, "PNG", 14, 10, 40, 24);
    }

    const gmailImg = new Image();
    gmailImg.src = gmail;

    const phoneImg = new Image();
    phoneImg.src = phone;

    pdf.setFontSize(14);
    pdf.setFont("Helvetica", "Bold");
    pdf.text(agency.name || "AGENCE", 24, 45);
    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    pdf.text(agency.address || "", 15, 50);
    pdf.text((agency.postCode || "") + " " + (agency.town || ""), 15, 55);
    pdf.text("SIRET  : " + (agency.siret || ""), 15, 60);
    pdf.text("TVA n° : " + (agency.tva || agency.TVA || ""), 15, 65);
    pdf.addImage(gmailImg, "PNG", 15, 67, 3, 3);

    pdf.text(" : " + (agency.email || ""), 18, 69.5);
    pdf.addImage(phoneImg, "PNG", 15, 71.5, 3, 3);
    pdf.text(" : " + (agency.phone || ""), 18, 74);
    const creatorFirst = quotation.creator?.firstname || "";
    const creatorLast = quotation.creator?.lastname || "";
    if (creatorFirst || creatorLast) {
      pdf.text("Contact : " + creatorFirst + " " + creatorLast, 15, 79.5);
    }

    pdf.setFontSize(14);
    pdf.setFont("Helvetica", "Bold");
    if (quotation.quotationNumber && !quotation.isDraft) {
      pdf.text(
        "Devis n° " +
          formatJsDate2(quotation.createdAt) +
          "-" +
          quotation.quotationNumber.toString().padStart(5, 0),
        110,
        45,
      );
    } else {
      pdf.text("Devis provisoire", 110, 45);
    }

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");

    pdf.text("Date : ", 110, 50);
    pdf.text(formatJsDate(quotation.createdAt), 120, 50);
    if (quotation.expiryDate) {
      pdf.text("Date d'expiration :", 110, 55);
      pdf.text(formatJsDate(quotation.expiryDate), 137, 55);
    }

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "Bold");
    pdf.text("Adresse de facturation :", 15, 95);

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    const addressFacturation = (quotation.addressFacturation ?? "")
      .toString()
      .trim();
    const addressMatch = addressFacturation.match(/^(.*?)\b(\d{5})\b(.*)$/);
    var [partieAvant, codePostal, partieApres] = addressMatch
      ? addressMatch.slice(1).map((str) => str.trim())
      : [addressFacturation, "", ""];
    try {
      pdf.text(partieAvant || addressFacturation, 15, 100);
      if (codePostal || partieApres) {
        pdf.text(codePostal + " " + partieApres, 15, 105);
      }
    } catch (e) {
      console.log(e);
    }

    pdf.setFontSize(12);
    pdf.setFont("Helvetica", "Bold");
    const companyName = (
      client.companyName ||
      client.denomination ||
      "CLIENT"
    ).toUpperCase();
    const companyNameArray = splitStringWithoutCuttingWords(companyName, 30);
    let companyY = 80 - (companyNameArray.length - 1) * 5;
    for (let name of companyNameArray) {
      pdf.text(name, 110, companyY);
      companyY += 5;
    }

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    // On retire email (@) et téléphone (chiffres) pour n'afficher que le nom.
    const contact = (quotation.contact ?? "")
      .toString()
      .split(" ")
      .filter((part) => part && !part.includes("@") && !/\d/.test(part))
      .join(" ")
      .trim();
    pdf.text(contact.toUpperCase(), 110.5, 85);
    pdf.text(partieAvant || addressFacturation, 110.5, 90);
    if (codePostal || partieApres) {
      pdf.text(codePostal + " " + partieApres, 110.5, 95);
    }
    pdf.text("SIRET : " + (client.siret || ""), 110.5, 100);
    pdf.text("TVA : " + (client.TVA || client.tva || ""), 110.5, 105);

    pdf.setFontSize(12);
    pdf.setFont("Helvetica", "bold");
    pdf.setTextColor(9, 132, 227);
    pdf.setDrawColor(9, 132, 227);

    // Vacation affiché comme Placement (aligné admin).
    if (mainProduct === "Placement" || mainProduct === "Vacation") {
      pdf.roundedRect(26, 115, 160, 30, 1, 1);
      pdf.text(mainProduct.toUpperCase(), 95, 120);
      pdf.line(95, 122, 122, 122);

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);

      pdf.text(
        "Vous nous mandatez pour recruter au sein de votre entreprise, un poste en CDD ou CDI.",
        46,
        130,
      );
      pdf.text(
        "Le contrat, la DPAE et la fiche de paie sont établis par vos soins. Vous êtes l'employeur.",
        46,
        135,
      );
      pdf.text("Vous recevrez une seule facture pour le placement", 57, 140);
    }

    if (
      mainProduct === "Délégation" ||
      mainProduct === "Gestion"
    ) {
      pdf.roundedRect(15, 110, 92, 35, 1, 1);
      pdf.roundedRect(110, 110, 92, 35, 1, 1);
      pdf.text("DELEGATION", 47, 115);
      pdf.line(47, 117, 75, 117);
      pdf.text("GESTION", 145, 115);
      pdf.line(145, 117, 164, 117);

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);

      pdf.text("Vous nous mandatez pour", 17, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("recruter", 55, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text("   et", 65, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("  gérer", 70, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text(" l'administratif", 80, 125);
      pdf.text("de ", 17, 130);
      pdf.setFont("Helvetica", "bold");
      pdf.text("notre", 21, 130);
      pdf.setFont("Helvetica", "normal");
      pdf.text("recrue. Le contrat, la DPAE et la fiche de paie sont", 30, 130);
      pdf.text(
        "établis par nous, qui sommes l'employeur. Vous avez à charge",
        17,
        135,
      );
      pdf.text(
        "la sécurité du salarié. Vous recevrez une facture mensuelle.",
        17,
        140,
      );

      pdf.text("Vous nous mandatez pour", 112, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("gérer", 150, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text("simplement l'administratif", 159, 125);
      pdf.text("de", 112, 130);
      pdf.setFont("Helvetica", "bold");
      pdf.text("votre", 116, 130);
      pdf.setFont("Helvetica", "normal");
      pdf.text(
        "recrue. Le contrat, la DPAE et la fiche de paie sont",
        125,
        130,
      );
      pdf.text(
        "établis par nous, qui sommes l'employeur. Vous avez à charge",
        112,
        135,
      );
      pdf.text(
        "la sécurité du salarié. Vous recevrez une facture mensuelle.",
        112,
        140,
      );
    }

    pdf.setTextColor(0, 0, 0);

    pdf.setFillColor(9, 132, 227);
    pdf.setDrawColor(9, 132, 227);
    pdf.rect(15, 155, 180, 10, "F");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "bold");

    if (
      mainProduct === "Délégation" ||
      mainProduct === "Gestion"
    ) {
      let height = 170;

      pdf.text("Designation", 25, 161);
      pdf.text("Taux horaire", 60, 161);
      pdf.text("Coefficient", 95, 161);
      pdf.text("Prix HT/heure", 130, 159);
      pdf.text("travaillée", 135, 163);
      pdf.text("Observation", 165, 161);

      pdf.setFontSize(10);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);

      products.map((product, idx) => {
        const primeTypes = [
          "Prime",
          "Indemnité",
          "Prime Ségur",
          "Primes diverses",
          "Autre",
        ];
        if (primeTypes.includes(product.type) && product.type !== "Autre") {
          const prime = splitStringWithoutCuttingWords(
            product.type + " : " + (product.product || ""),
            24,
          );
          for (let i = 0; i < prime.length; i++) {
            pdf.text(prime[i], 20, height);
            height += 5;
          }
          height -= 5;
        } else if (product.type === "Autre") {
          pdf.text(product.product || "", 20, height);
        } else {
          pdf.text((product.product || "") + " H/F", 20, height);
          const poste = splitStringWithoutCuttingWords(product.poste || "", 24);
          for (let i = 0; i < poste.length; i++) {
            pdf.text(poste[i], 20, height + 5);
            height += 5;
          }
        }
        const hasTaux = product.taux !== "" && product.taux != null;
        const hasCoeff =
          product.coefficient !== "" && product.coefficient != null;
        if (hasTaux) {
          pdf.text(parseFloat(product.taux).toFixed(2) + "€", 65, height);
        }
        if (hasCoeff) {
          pdf.text(String(product.coefficient), 105, height);
        }
        if (hasTaux && hasCoeff) {
          pdf.text(
            (
              parseFloat(product.taux) * parseFloat(product.coefficient)
            ).toFixed(2) + "€",
            140,
            height,
          );
        }
        const commentLines = splitStringWithoutCuttingWords(
          product.comment || "",
          24,
        );
        for (let i = 0; i < commentLines.length; i++) {
          pdf.text(commentLines[i], 165, height);
          if (i < commentLines.length - 1) height += 5;
        }
        height += 5;
        pdf.setTextColor(128, 128, 128);
        pdf.setDrawColor(128, 128, 128);
        if (product.minimumHours) {
          pdf.text(
            "Nombre d'heures minimales avant embauche sans facturation : " +
              product.minimumHours +
              "h",
            50,
            height,
          );
          height += 3;
        }

        if (idx === products.length - 1) {
          pdf.setDrawColor(0, 0, 0);
          pdf.setLineWidth(0.5);
        }
        pdf.line(15, height, 195, height);
        pdf.setTextColor(0, 0, 0);
        pdf.setDrawColor(0, 0, 0);
        height += 7;
        if (height > 260) {
          pdf.addPage();
          height = 10;
        }
      });

      height += 10;
      if (height > 250) {
        pdf.addPage();
        height = 10;
      }

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");

      pdf.text("Nom et qualité du signataire :", 15, height);
      pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

      pdf.text(String(client.tvaRate || ""), 120, height);
      pdf.text(
        "Conditions de paiement : " + (client.facturation || ""),
        120,
        height + 5,
      );
      pdf.text("Moyen de règlement : Virement/Chèque/CB", 120, height + 10);
    }

    if (mainProduct === "Placement" || mainProduct === "Vacation") {
      let height = 170;

      pdf.text("Designation", 25, 161);
      pdf.text("Quantité", 68, 161);
      pdf.text("PU (HT)", 110, 161);
      pdf.text("Montant (HT)", 160, 161);

      pdf.setFontSize(10);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);

      products.map((product, idx) => {
        pdf.text((product.product || "") + " H/F", 20, height);
        pdf.text(product.poste || "", 20, height + 5);
        height += 5;
        const taux = parseFloat(product.taux);
        const coeff = parseFloat(product.coefficient);
        const safeTaux = Number.isFinite(taux) ? taux : 0;
        const safeCoeff = Number.isFinite(coeff) ? coeff : 0;
        pdf.text(safeTaux.toFixed(2) + "€", 110, height);
        pdf.text(String(product.coefficient ?? ""), 75, height);
        pdf.text((safeTaux * safeCoeff).toFixed(2) + "€", 175, height);
        height += 5;
        pdf.setTextColor(128, 128, 128);
        pdf.setDrawColor(128, 128, 128);

        if (idx === products.length - 1) {
          pdf.setDrawColor(0, 0, 0);
          pdf.setLineWidth(0.5);
        }
        pdf.line(15, height, 195, height);
        pdf.setTextColor(0, 0, 0);
        pdf.setDrawColor(0, 0, 0);
        height += 7;
        if (height > 260) {
          pdf.addPage();
          height = 10;
        }
      });

      if (height > 250) {
        pdf.addPage();
        height = 10;
      }

      pdf.setFillColor(135, 177, 255);
      pdf.setDrawColor(9, 132, 227);
      height += 6;
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("Helvetica", "Bold");

      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "normal");

      const totalHt = products.reduce((total, item) => {
        const t = parseFloat(item.taux);
        return total + (Number.isFinite(t) ? t : 0);
      }, 0);

      pdf.text("Total HT", 110, height);
      pdf.text(totalHt.toFixed(2) + " €", 174, height);

      height += 10;

      pdf.text((totalHt * 0.2).toFixed(2) + " €", 174, height);
      height += 10;
      pdf.setFillColor(9, 132, 227);
      pdf.rect(105, height - 7, 90, 10, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.text("Total TTC", 110, height);
      pdf.text((totalHt * 1.2).toFixed(2) + " €", 174, height);

      pdf.setTextColor(0, 0, 0);

      height += 10;

      if (height >= 270) pdf.addPage();

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");

      if (height > 280) {
        pdf.addPage();
        height = 10;
      }

      const firstProduct = products[0] || {};
      const paymentCondition = splitStringWithoutCuttingWords(
        "Conditions de paiement : " + (firstProduct.comment || ""),
        70,
      );
      const replaceCondition = splitStringWithoutCuttingWords(
        "Conditions de remplacement : " + (firstProduct.comment2 || ""),
        70,
      );
      pdf.text("Nom et qualité du signataire :", 15, height);
      pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

      pdf.text("Moyen de règlement : Virement/Chèque/CB", 90, height);
      for (let x of paymentCondition) {
        pdf.text(x, 90, height + 5);
        height += 5;
        if (height >= 280) {
          pdf.addPage();
          height = 10;
        }
      }
      for (let x of replaceCondition) {
        pdf.text(x, 90, height + 10);
        height += 10;
        if (height >= 280) {
          pdf.addPage();
          height = 10;
        }
      }
    }

    pdf.text(
      `J'm intérim - SAS au capital de 80 000 € - 4 Avenue Laurent Cély, Hall A, 92600 Asnières sur Seine, France`,
      25,
      280,
    );
    pdf.text(
      "SIRET : 91912551800010 - Code APE : 7820z - N° de TVA : FR52919125518",
      50,
      285,
    );

    pdf.addPage();
    pdf.addImage(cgvClient, "PNG", 10, 10, 198, 282);

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    if (viewOnly) {
      // Pour la visualisation, ouvrir dans un nouvel onglet
      window.open(pdfUrl, "_blank");
    } else {
      // Pour le téléchargement, déclencher le téléchargement
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `Devis_${quotation.quotationNumber || 'Provisoire'}_${formatJsDate2(quotation.createdAt)}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Libérer l'URL après le téléchargement
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
    }
    } catch (e) {
      console.error("Erreur génération PDF devis:", e);
      message.error("Impossible d'afficher ce devis. Vérifiez les données du devis.");
    } finally {
      setIsLoadingQuotation(false);
    }
  };

  const atradiusValues = ["Accepté", "Refusé", "En arbitrage"];

  const atradiusValueArray = atradiusValues.map((atradiusValue) => {
    return {
      value: atradiusValue,
      label: atradiusValue,
    };
  });

  const epiProps = {
    treeData: epiData,
    onChange: onChangeEpi,
    value: epis,
    treeCheckable: true,
    placeholder: "EPI",
  };

  const setAtradius = (atradiusValue) => {
    if (atradiusValue === "Accepté") {
      setAcceptedAtradius(true);
    } else {
      setAcceptedAtradius(false);
    }
  };

  function splitStringWithoutCuttingWords(inputString, chunkSize) {
    const words = String(inputString ?? "").split(" ");
    const resultChunks = [];
    let currentChunk = "";

    for (const word of words) {
      if (currentChunk.length + word.length <= chunkSize) {
        currentChunk += (currentChunk ? " " : "") + word;
      } else {
        if (currentChunk) resultChunks.push(currentChunk);
        currentChunk = word;
      }
    }

    if (currentChunk) {
      resultChunks.push(currentChunk);
    }

    return resultChunks;
  }

  const formatJsDate2 = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, "0");
    const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    const year = newDate.getFullYear();

    return `${month}${year}`;
  };

  const deleteContact = (contacts, idx) => {
    console.log(contacts);
    console.log(idx);
    const newContacts = [...contacts];
    newContacts.splice(idx, 1);
    axios
      .patch(`client/${client._id}`, { contacts: newContacts })
      .then((res) => {
        setUpdateContactObject({});
        const clientIdx = originalClients.findIndex(
          (c) => c._id === client._id,
        );
        const newClients = [...originalClients];
        newClients[clientIdx] = res.data;
        setClient(res.data);
        setClients(newClients);
        message.success("Contact supprimé ! ");
        setIsOpenCreateContact(false);
      })
      .catch((e) => {
        message.error("une erreur s'est produite ! ");
      });
  };

  const formatJsDate = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, "0");
    const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    const year = newDate.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const filter = (array, word) => {
    const excludedFields = ["_id", "user"];
    word = word.toLowerCase();
    return array.filter((obj) => {
      const stringObj = JSON.stringify(obj).toLowerCase();
      return stringObj.includes(word.toLowerCase());
      /* for (const key in obj) {
        if (obj.hasOwnProperty(key) && !excludedFields.includes(key)) {
          const value = obj[key]

          if (typeof value === 'string' && value.toLowerCase().includes(word)) {
            return true
          }
          if (typeof value === 'object') {
            if (value.join('').toLowerCase().includes(word)) {
              return true
            }
          }
        }
      } */
    });
  };

  const createPldContract = () => {
    if (canCreateContract) setIsCreatePldContract(true);
    else
      message.error("Le client n'a pas de numéro PLD ! Demander sa création");
    console.log(canCreateContract);
  };

  const updateContacts = () => {
    axios
      .patch(`client/${client._id}`, {
        contacts: [...client.contacts, updateContactObject],
      })
      .then((res) => {
        setUpdateContactObject({});
        const clientIdx = originalClients.findIndex(
          (c) => c._id === client._id,
        );
        const newClients = [...originalClients];
        newClients[clientIdx] = res.data;
        setClient(res.data);
        setClients(newClients);
        message.success("Contact créé ! ");
        setIsOpenCreateContact(false);
      })
      .catch((e) => {
        message.error("une erreur s'est produite ! ");
      });
  };

  const askAtradius = () => {
    setIsLoadingAtradius(true);
    if (!client.siret) {
      message.error("Le client doit avoir un numero de siret");
      return;
    }
    if (amount.length === 0) {
      message.error("Veuillez entrer un montant entier !");
      return;
    }
    const siren = client.siret.trim().substring(0, 9);
    axios
      .post("cover/new-cover", { amount, siren, clientId: client._id })
      .then((res) => {
        console.log(res);
        message.success("Cote demandée !");
        setIsAskAtradius(false);
      })
      .catch((e) => {
        console.log(e);
        message.error("Une erreur s'est produite !");
      })
      .finally(() => {
        setIsLoadingAtradius(false);
      });
  };

  function formatPhoneNumber(input) {
    const formatted = input.replace(/\B(?=(\d{2})+(?!\d))/g, " ");
    return formatted;
  }

  const formatDate = (dateString) => {
    if (!dateString) return "Non renseigné";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "Date invalide";
    }

    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const formatAmount = (amount, decimals = 0) => {
    if (!amount || amount === null || amount === undefined) {
      return "Non renseigné";
    }

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) {
      return "Non renseigné";
    }

    return decimals > 0 ? numAmount.toFixed(decimals) : numAmount.toLocaleString();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "actif":
        return "bg-green-100 text-green-800";
      case "prospect":
        return "bg-orange-100 text-orange-800";
      case "inactif":
        return "bg-red-100 text-red-800";
      default:
        return "bg-green-100 text-green-800";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "actif":
        return <CheckCircle2 className="w-4 h-4" />;
      case "prospect":
        return <Clock className="w-4 h-4" />;
      case "inactif":
        return <AlertCircle className="w-4 h-4" />;
      default:
        return <CheckCircle2 className="w-4 h-4" />;
    }
  };

  return (
    <AnimatePresence>
      {client && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[90vh] overflow-hidden"
          >
            {/* Header */}
            <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-6 border-b border-slate-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-100 p-3 rounded-xl">
                    <Building className="w-8 h-8 text-blue-600" />
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-slate-900">{client.companyName}</h1>
                    <div className="flex items-center space-x-3 mt-1">
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(client.status || "actif")}`}>
                        {getStatusIcon(client.status || "actif")}
                        <span className="ml-1">
                          {client.status === "actif" || !client.status ? "Client actif" :
                           client.status === "prospect" ? "Prospect" : "Inactif"}
                        </span>
                      </span>
                      {client.pld && (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                          <Target className="w-4 h-4 mr-1" />
                          PLD: {client.pld}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => {
                    setClient(null);
                    setSection("info");
                  }}
                  className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-all duration-200"
                >
                  <X className="w-6 h-6" />
                </motion.button>
              </div>
            </div>
            {/* Main Content */}
            <div className="flex h-full">
              {/* Sidebar */}
              <div className="w-80 bg-slate-50 border-r border-slate-200 p-6 overflow-y-auto">
                {/* Client Info Card */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-6"
                >
                  <h3 className="text-lg font-semibold text-slate-900 mb-4">Informations principales</h3>
                  <div className="space-y-3">
                    <div className="flex items-center text-sm">
                      <User className="w-4 h-4 text-slate-400 mr-3" />
                      <span className="text-slate-600">Commercial:</span>
                      <span className="ml-2 font-medium text-slate-900">{client.commercial || "Non assigné"}</span>
                    </div>
                    <div className="flex items-center text-sm">
                      <Mail className="w-4 h-4 text-slate-400 mr-3" />
                      <span className="text-slate-600">Email:</span>
                      <span className="ml-2 font-medium text-slate-900">{client.contactEMail || "Non renseigné"}</span>
                    </div>
                    <div className="flex items-center text-sm">
                      <Phone className="w-4 h-4 text-slate-400 mr-3" />
                      <span className="text-slate-600">Téléphone:</span>
                      <span className="ml-2 font-medium text-slate-900">{client.contactPhone || "Non renseigné"}</span>
                    </div>
                    <div className="flex items-center text-sm">
                      <MapPin className="w-4 h-4 text-slate-400 mr-3" />
                      <span className="text-slate-600">Ville:</span>
                      <span className="ml-2 font-medium text-slate-900">{client.town || "Non renseigné"}</span>
                    </div>
                  </div>
                </motion.div>

                {/* Quick Actions */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.1 }}
                  className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-6"
                >
                  <h3 className="text-lg font-semibold text-slate-900 mb-4">Actions rapides</h3>
                  <div className="space-y-3">
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => setIsCreateQuotation(true)}
                      className="w-full flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg transition-colors duration-200"
                    >
                      <FileText className="w-4 h-4" />
                      <span>Créer un devis</span>
                    </motion.button>

                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => setIsAskAtradius(true)}
                      className="w-full flex items-center justify-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-4 py-3 rounded-lg transition-colors duration-200"
                    >
                      <Shield className="w-4 h-4" />
                      <span>Demander cote Atradius</span>
                    </motion.button>

                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => createPldContract()}
                      className="w-full flex items-center justify-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-lg transition-colors duration-200"
                    >
                      <Briefcase className="w-4 h-4" />
                      <span>Créer contrat PLD</span>
                    </motion.button>
                  </div>
                </motion.div>

                {/* Statistics */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2 }}
                  className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                >
                  <h3 className="text-lg font-semibold text-slate-900 mb-4">Chiffre d'affaires</h3>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-600">CA 2023:</span>
                      <span className="font-medium text-slate-900">Non renseigné</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-600">CA 2022:</span>
                      <span className="font-medium text-slate-900">Non renseigné</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-600">CA 2021:</span>
                      <span className="font-medium text-slate-900">Non renseigné</span>
                    </div>
                  </div>
                </motion.div>
              </div>
              {/* Main Content Area */}
              <div className="flex-1 flex flex-col">
                {/* Tabs Navigation */}
                <div className="bg-white border-b border-slate-200 px-6">
                  <div className="flex space-x-1">
                    {[
                      { id: "info", label: "Informations", icon: Building },
                      { id: "contact", label: "Contacts", icon: Users },
                      { id: "devis", label: "Devis", icon: FileText },
                      { id: "financial", label: "Atradius", icon: Shield },
                      { id: "event", label: "Événements", icon: Calendar },
                      { id: "file", label: "Fichiers", icon: FileText },
                      { id: "commentaire", label: "Commentaires", icon: MessageSquare },
                    ].map((tab) => {
                      const Icon = tab.icon;
                      return (
                        <motion.button
                          key={tab.id}
                          whileHover={{ y: -2 }}
                          onClick={() => setSection(tab.id)}
                          className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-all duration-200 ${
                            section === tab.id
                              ? "border-blue-500 text-blue-600 bg-blue-50"
                              : "border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300"
                          }`}
                        >
                          <Icon className="w-4 h-4" />
                          <span>{tab.label}</span>
                        </motion.button>
                      );
                    })}
                  </div>
                </div>

                {/* Tab Content */}
                <div className="flex-1 overflow-y-auto p-6">
                  {/* Informations Tab */}
                  {section === "info" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* Adresses */}
                        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                          <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center">
                            <MapPin className="w-5 h-5 mr-2 text-blue-600" />
                            Adresses
                          </h3>
                          <div className="space-y-4">
                            <div>
                              <label className="text-sm font-medium text-slate-600">Siège social</label>
                              <p className="text-slate-900 mt-1">
                                {client.address}, {client.postCode} {client.town}
                              </p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-slate-600">Adresse de livraison</label>
                              <p className="text-slate-900 mt-1">
                                {client.addressLivraison || client.address}, {client.postCodeLivraison || client.postCode} {client.townLivraison || client.town}
                              </p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-slate-600">Adresse de facturation</label>
                              <p className="text-slate-900 mt-1">
                                {client.addressFacturation || client.address}, {client.postCodeFacturation || client.postCode} {client.townFacturation || client.town}
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Informations légales */}
                        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                          <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center">
                            <Building className="w-5 h-5 mr-2 text-green-600" />
                            Informations légales
                          </h3>
                          <div className="space-y-4">
                            <div>
                              <label className="text-sm font-medium text-slate-600">SIRET</label>
                              <p className="text-slate-900 mt-1 font-mono">{client.siret || "Non renseigné"}</p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-slate-600">Code APE</label>
                              <p className="text-slate-900 mt-1">{client.APE || "Non renseigné"}</p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-slate-600">TVA Intracommunautaire</label>
                              <p className="text-slate-900 mt-1">{client.TVA || "Non renseigné"}</p>
                            </div>
                          </div>
                        </div>

                        {/* Conditions commerciales */}
                        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                          <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center">
                            <CreditCard className="w-5 h-5 mr-2 text-purple-600" />
                            Conditions commerciales
                          </h3>
                          <div className="space-y-4">
                            <div>
                              <label className="text-sm font-medium text-slate-600">Conditions de paiement</label>
                              <p className="text-slate-900 mt-1">{client.facturation || "Non renseigné"}</p>
                            </div>
                            <div>
                              <label className="text-sm font-medium text-slate-600">Taux de TVA</label>
                              <p className="text-slate-900 mt-1">{client.tvaRate || "20%"}</p>
                            </div>
                          </div>
                        </div>

                        {/* Acquisition client */}
                        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                          <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center">
                            <Target className="w-5 h-5 mr-2 text-orange-600" />
                            Acquisition
                          </h3>
                          <div className="space-y-4">
                            <div>
                              <label className="text-sm font-medium text-slate-600">Mode d'acquisition</label>
                              <p className="text-slate-900 mt-1">{client.clientAcquisition || "Non renseigné"}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )}

                  {/* Contacts Tab */}
                  {section === "contact" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-slate-900">Contacts</h3>
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setIsOpenCreateContact(true)}
                          className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Ajouter un contact</span>
                        </motion.button>
                      </div>

                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-slate-200">
                            <thead className="bg-slate-50">
                              <tr>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Contact
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Poste
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Email
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Téléphone
                                </th>
                                <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-slate-200">
                              {client.contacts && client.contacts.length > 0 ? (
                                client.contacts.map((contact, index) => (
                                  <motion.tr
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                    className="hover:bg-slate-50 transition-colors duration-200"
                                  >
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="flex items-center">
                                        <div className="bg-slate-100 p-2 rounded-lg mr-3">
                                          <User className="w-4 h-4 text-slate-600" />
                                        </div>
                                        <div>
                                          <div className="text-sm font-medium text-slate-900">
                                            {contact.title} {contact.firstname} {contact.lastname}
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">{contact.profession || "Non renseigné"}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">{contact.email || "Non renseigné"}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">{contact.mobile || contact.phone || "Non renseigné"}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                      <div className="flex items-center justify-center space-x-2">
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                                          title="Modifier"
                                        >
                                          <Edit className="w-4 h-4" />
                                        </motion.button>
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          onClick={() => deleteContact(client.contacts, index)}
                                          className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200"
                                          title="Supprimer"
                                        >
                                          <Trash2 className="w-4 h-4" />
                                        </motion.button>
                                      </div>
                                    </td>
                                  </motion.tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5" className="px-6 py-12 text-center">
                                    <div className="flex flex-col items-center">
                                      <Users className="w-12 h-12 text-slate-300 mb-4" />
                                      <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun contact</h3>
                                      <p className="text-slate-500">Commencez par ajouter un contact pour ce client</p>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </motion.div>
                  )}

                  {/* Devis Tab */}
                  {section === "devis" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-slate-900">Devis</h3>
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setIsCreateQuotation(true)}
                          className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Nouveau devis</span>
                        </motion.button>
                      </div>

                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        {quotations && quotations.length > 0 ? (
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-slate-200">
                              <thead className="bg-slate-50">
                                <tr>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Numéro
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Date
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Expiration
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Montant
                                  </th>
                                  <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-slate-200">
                                {quotations.map((quotation, index) => (
                                  <motion.tr
                                    key={quotation._id || index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                    className="hover:bg-slate-50 transition-colors duration-200"
                                  >
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm font-medium text-slate-900">
                                        #{quotation.quotationNumber || "Provisoire"}
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">
                                        {formatDate(quotation.createdAt)}
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">
                                        {formatDate(quotation.expiryDate)}
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm font-medium text-slate-900">
                                        {quotation.products && quotation.products.length > 0
                                          ? `${formatAmount(
                                              quotation.products.reduce((total, item) => {
                                                const taux = parseFloat(item.taux)
                                                const coeff = parseFloat(item.coefficient)
                                                const t = Number.isFinite(taux) ? taux : 0
                                                const c = Number.isFinite(coeff) ? coeff : 1
                                                // Placement: montant = taux ; Délégation: taux * coeff
                                                const type = quotation.products[0]?.product
                                                if (type === 'Placement' || type === 'Vacation') {
                                                  return total + t
                                                }
                                                return total + t * c
                                              }, 0),
                                              2,
                                            )} €`
                                          : "Non calculé"
                                        }
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                      <div className="flex items-center justify-center space-x-2">
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          onClick={() => generatePDF(quotation, true)}
                                          disabled={isLoadingQuotation}
                                          className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200 disabled:opacity-50"
                                          title="Voir le PDF"
                                        >
                                          {isLoadingQuotation ? (
                                            <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                                          ) : (
                                            <Eye className="w-4 h-4" />
                                          )}
                                        </motion.button>
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          onClick={() => generatePDF(quotation, false)}
                                          disabled={isLoadingQuotation}
                                          className="p-2 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-all duration-200 disabled:opacity-50"
                                          title="Télécharger PDF"
                                        >
                                          {isLoadingQuotation ? (
                                            <div className="w-4 h-4 border-2 border-green-600 border-t-transparent rounded-full animate-spin"></div>
                                          ) : (
                                            <Download className="w-4 h-4" />
                                          )}
                                        </motion.button>
                                      </div>
                                    </td>
                                  </motion.tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="px-6 py-12 text-center">
                            <div className="flex flex-col items-center">
                              <FileText className="w-12 h-12 text-slate-300 mb-4" />
                              <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun devis</h3>
                              <p className="text-slate-500">Commencez par créer un devis pour ce client</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}

                  {/* Financial/Atradius Tab */}
                  {section === "financial" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-slate-900 flex items-center">
                          <Shield className="w-5 h-5 mr-2 text-purple-600" />
                          Couverture Atradius
                        </h3>
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setIsAskAtradius(true)}
                          className="flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Demander une cote</span>
                        </motion.button>
                      </div>

                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        {cover ? (
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-slate-200">
                              <thead className="bg-slate-50">
                                <tr>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Date demande
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Type
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Montant demandé
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Montant accordé
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Facture en cours
                                  </th>
                                  <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    État
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                <tr>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                    {formatDate(cover._doc?.decisionDate)}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                    {cover._doc?.coverType || "Non renseigné"}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                                    {formatAmount(cover._doc?.creditLimitApplicationAmountInPolicyCurrency)} €
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                                    {formatAmount(cover._doc?.totalDecision?.decisionAmtInPolicyCurrency)} €
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                    {formatAmount(cover.montantNonFacture, 2)} €
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-center">
                                    {cover._doc?.totalDecision?.decisionAmtInPolicyCurrency === "0" ? (
                                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                        <AlertCircle className="w-3 h-3 mr-1" />
                                        Refusée
                                      </span>
                                    ) : cover.montantNonFacture <= cover._doc?.totalDecision?.decisionAmtInPolicyCurrency ? (
                                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                        <CheckCircle2 className="w-3 h-3 mr-1" />
                                        OK
                                      </span>
                                    ) : (
                                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                                        <Clock className="w-3 h-3 mr-1" />
                                        À revoir
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="px-6 py-12 text-center">
                            <div className="flex flex-col items-center">
                              <Shield className="w-12 h-12 text-slate-300 mb-4" />
                              <h3 className="text-lg font-medium text-slate-900 mb-2">Aucune couverture Atradius</h3>
                              <p className="text-slate-500">Demandez une cote pour ce client</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}

                  {/* Events Tab */}
                  {section === "event" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-slate-900 flex items-center">
                          <Calendar className="w-5 h-5 mr-2 text-green-600" />
                          Événements
                        </h3>
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          className="flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Nouvel événement</span>
                        </motion.button>
                      </div>

                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                        <div className="text-center py-12">
                          <Calendar className="w-12 h-12 text-slate-300 mx-auto mb-4" />
                          <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun événement</h3>
                          <p className="text-slate-500">Les événements liés à ce client apparaîtront ici</p>
                        </div>
                      </div>
                    </motion.div>
                  )}

                  {/* Files Tab */}
                  {section === "file" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-slate-900 flex items-center">
                          <FileText className="w-5 h-5 mr-2 text-orange-600" />
                          Fichiers
                        </h3>
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          className="flex items-center space-x-2 bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Ajouter un fichier</span>
                        </motion.button>
                      </div>

                      <ClientDocuments client={client} />
                    </motion.div>
                  )}

                  {/* Comments Tab */}
                  {section === "commentaire" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-6"
                    >
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-slate-900 flex items-center">
                          <MessageSquare className="w-5 h-5 mr-2 text-yellow-600" />
                          Commentaires
                        </h3>
                      </div>

                      <ClientComment client={client} clients={clients} setClients={setClients} />
                    </motion.div>
                  )}
                </div>
              </div>
            </div>

            {/* Modals */}
            {isCreatePldContract && (
              <CreateContract
                client={client}
                qualifications={clientQualifications}
                chantiers={clientChantiers}
                isCreateContract={isCreatePldContract}
                setIsCreateContract={setIsCreatePldContract}
              />
            )}

            {isAskAtradius && (
              <Modal
                open={isAskAtradius}
                footer={null}
                onCancel={() => setIsAskAtradius(false)}
              >
                <div className="flex flex-col mt-10 items-center justify-center space-y-4">
                  <input
                    onChange={(e) => setAmount(e.target.value)}
                    className="border outline-none border-gray-300 w-96 rounded-md p-2"
                    placeholder="Montant"
                  />
                  <button
                    onClick={askAtradius}
                    className="p-2 text-white rounded-md w-96 text-center bg-purple-500"
                  >
                    {!isLoadingAtradius && <span>Demander cote atradius</span>}
                    {isLoadingAtradius && <span>...Patientez</span>}
                  </button>
                </div>
              </Modal>
            )}

            {isOpenCreateContact && (
              <Modal
                footer={null}
                width={900}
                open={isOpenCreateContact}
                onCancel={() => setIsOpenCreateContact(false)}
                className="z-30"
              >
                <div className="flex items-center space-x-2 mb-6 mt-12">
                  <Select
                    className="px-2  placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                    onChange={(e) =>
                      setUpdateContactObject({ ...updateContactObject, title: e })
                    }
                    value={updateContactObject.title}
                    optionFilterProp="children"
                    placeholder="Civilité"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        label: "M.",
                        value: "M.",
                        key: "M.",
                      },
                      {
                        label: "Mme",
                        value: "Mme",
                        key: "Mme",
                      },
                    ]}
                  />
                  <Input
                    placeholder="Prénom"
                    onChange={(e) =>
                      setUpdateContactObject({
                        ...updateContactObject,
                        firstname: e.target.value,
                      })
                    }
                    value={updateContactObject.firstname}
                    className="px-2  placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                  />
                  <Input
                    placeholder="Nom"
                    onChange={(e) =>
                      setUpdateContactObject({
                        ...updateContactObject,
                        lastname: e.target.value,
                      })
                    }
                    value={updateContactObject.lastname}
                    className="px-2  placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                  />
                </div>

                <Input
                  placeholder="Profession"
                  onChange={(e) =>
                    setUpdateContactObject({
                      ...updateContactObject,
                      profession: e.target.value,
                    })
                  }
                  value={updateContactObject.profession}
                  className="px-2 mb-6 placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                />

                <div className="mb-6 flex items-center space-x-2">
                  <Input
                    placeholder="Téléphone fixe"
                    onChange={(e) =>
                      setUpdateContactObject({
                        ...updateContactObject,
                        phone: e.target.value,
                      })
                    }
                    value={updateContactObject.phone}
                    className="px-2  placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                  />
                  <Input
                    placeholder="Téléphone portable"
                    onChange={(e) =>
                      setUpdateContactObject({
                        ...updateContactObject,
                        mobile: e.target.value,
                      })
                    }
                    value={updateContactObject.mobile}
                    className="px-2 placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                  />
                </div>

                <Input
                  placeholder="Email"
                  onChange={(e) =>
                    setUpdateContactObject({
                      ...updateContactObject,
                      email: e.target.value,
                    })
                  }
                  value={updateContactObject.email}
                  className="px-2 mb-6  placeholder-gray-300 py-1 outline-none text-black border rounded-md border-gray-200 "
                />

                <p className="text-right">
                  <button
                    onClick={updateContacts}
                    className="bg-blue-600 hover:bg-blue-700 p-3 rounded-md text-white transition-colors duration-200"
                  >
                    Enregistrer
                  </button>
                </p>
              </Modal>
            )}

            {isCreateQuotation && (
              <CreateQuotationModal
                client={client}
                isCreateQuotation={isCreateQuotation}
                setIsCreateQuotation={setIsCreateQuotation}
              />
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ClientDetail;
